let initialState = {
    budget: { min: 0, max: 500, changed:false },
    starRating: new Set(),
    info: new Set(),
    offers: new Set(),
    target: '',
    availableHotelAmenities: [],
    availableRoomAmenities: [],
    availableRoomCategory: [],
    availableBoardBasis: [],
    budgetMax: 500
};

let sortAndFilterReducer = function(data = initialState, action) {
    switch (action.type) {
        case 'APPLY_FILTER':
            return action.data;
        default:
            return data;
    }
};

export default sortAndFilterReducer;
